import axiosInstance from '@/axiosInstance'
import { getApiUrl } from '@/helper'

import { URL } from '../../constatns'

export const healthCheck = async () => {
  return axiosInstance.get(`${getApiUrl()}${URL}/health-check`)
}
